// Reference: https://jasonwatmore.com/post/2019/06/10/angular-8-user-registration-and-login-example-tutorial#login-component-html
// Firebase reference: https://stackoverflow.com/questions/51053699/interceptor-with-firebase-authentication

import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { AngularFireAuth } from '@angular/fire/compat/auth';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private auth: AngularFireAuth) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return this.auth.idToken.pipe(
            mergeMap((token: any) => {
                console.log(token);
                if (token) {
                  request = request.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
                }
                return next.handle(request);
            }));
    }
}